import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import * as moment from 'moment';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';
import {DATE_FORMAT} from '../../shared/constants/input.constants';
import {IContract} from '../../shared/model/contract.model';


type EntityResponseType = HttpResponse<IContract>;
type EntityArrayResponseType = HttpResponse<IContract[]>;

@Injectable({providedIn: 'root'})
export class ContractService {
  public resourceUrl = SERVER_API_URL + 'api/contracts';

  constructor(protected http: HttpClient) {
  }

  create(contract: IContract): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(contract);
    return this.http
      .post<IContract>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  update(contract: IContract): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(contract);
    return this.http
      .put<IContract>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<IContract>(`${this.resourceUrl}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  findContractMonthly(param:any): Observable<HttpResponse<any>> {
    return this.http
      .get<IContract>(`${this.resourceUrl + '-monthly/'+param}`, {observe: 'response'});
  }

  findContractSum(param:any): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-sum/'+param}`, {observe: 'response'});
  }
  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http
      .get<IContract[]>(this.resourceUrl, {params: options, observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }



  search(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IContract[]>(this.resourceUrl + '-search', {params: options, observe: 'response'});
  }

  findMyContractCount(id: number): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-self-count'}/${id}`, {observe: 'response'});
  }

  findMyContract(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IContract[]>(`${this.resourceUrl + '-self'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findContractTransaction(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IContract[]>(`${this.resourceUrl + '-transaction'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }
  findWithCustomerId(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<IContract[]>(`${this.resourceUrl + '-customer'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  protected convertDateFromClient(contract: IContract): IContract {
    const copy: IContract = Object.assign({}, contract, {
      // expiratioDate: contract.expiratioDate != null && contract.expiratioDate.isValid() ? contract.expiratioDate.format(DATE_FORMAT) : null
    });
    return copy;
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      // res.body.expiratioDate = res.body.expiratioDate != null ? moment(res.body.expiratioDate) : null;
    }
    return res;
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((contract: IContract) => {
        // contract.expiratioDate = contract.expiratioDate != null ? moment(contract.expiratioDate) : null;
      });
    }
    return res;
  }
}
